export default __webpack_public_path__ + "static/media/baseline-map-24px.4208fe32.svg";